import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { Colors } from '../../themes/colors';

interface Category {
  id: string;
  name: string;
}

interface CategoryBadgeProps {
  category: Category;
  count?: number;
  onCategorySelect?: (categoryId: string) => void;
  isSelected?: boolean;
}

export const CategoryBadge = ({ 
  category, 
  count, 
  onCategorySelect, 
  isSelected = false 
}: CategoryBadgeProps) => {
  const handlePress = () => {
    if (onCategorySelect) {
      onCategorySelect(category.id);
    }
  };
  

  return (
    <TouchableOpacity 
      key={`category-badge-${category.id}`}
      style={[
        styles.categoryBadge,
        isSelected && styles.categoryBadgeSelected
      ]}
      onPress={handlePress}
      activeOpacity={onCategorySelect ? 0.7 : 1} // Only show opacity change if pressable
    >
      <Text style={[
        styles.categoryText,
        isSelected && styles.categoryTextSelected
      ]}>
        {category.name} {count !== undefined && `(${count})`}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  categoryBadge: {
    backgroundColor: Colors.primaryGrayBackground, // Light gray background
    borderWidth: 1,
    borderColor: Colors.grayButtonBorder, // Dark gray border
    borderRadius: 14,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  categoryBadgeSelected: {
    backgroundColor: Colors.black, // Black background for selected
    borderColor: Colors.black,
  },
  categoryText: {
    fontSize: 12,
    color: Colors.grayText,
    fontWeight: '500',
  },
  categoryTextSelected: {
    color: Colors.white, // White text for selected
  },
});